<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-20 13:50:15
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-20 16:26:29
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/orderDetails/list/components/affiliationButton/index.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
  <span v-if="isBatch">
    <el-tooltip content="针对您筛选的全部结果进行批量修改订单">
      <el-button class="update-btn" type="text" @click="batchClickHandle">修改查询订单归属</el-button>
    </el-tooltip>
    <el-button type="text" @click="goToPage">修改记录</el-button>
  </span>
  <el-popover
    v-else
    placement="bottom-start"
    width="360"
    trigger="hover"
  >
    <div class="fz-14 yx-color-text-primary">
      <template v-if="noSelected">请先选择订单，可快速修改订单归属。</template>
      如需修改所有筛选结果订单建议使用<el-button
        type="text"
        @click="batchClickHandle"
        >修改查询订单归属</el-button
      >
    </div>
    <el-button slot="reference" @click="clickHandle"
      >修改订单归属</el-button
    >
  </el-popover>
</template>
<script>
export default {
  props: {
    platformId: {
      type: [Number, String],
      default: ''
    },
    mode: {
      type: String,
      default: 'single',
      validtor: val => !['single', 'batch'].includes(val)
    },
    selectArr: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    isBatch() {
      return this.mode === 'batch';
    },
    noSelected() {
      return this.selectArr.length === 0;
    }
  },
  methods: {
    goToPage() {
      const { platformId } = this;
      const { href } = this.$router.resolve({
        path: "/order/updateLog",
        query: { platformId },
      });
      window.open(href);
    },
    batchClickHandle() {
      this.$emit('onSubmit');
      this.$Bus.$emit('showAffiliationDialog');
    },
    clickHandle() {
      if(this.noSelected) return
      this.$Bus.$emit('showAffiliationDialog', this.selectArr);
    }
  }
}
</script>